module.exports = __webpack_public_path__ + "img/td_3d.2f8738d1.png";